import { IMG } from "./site";

// Category taxonomy retained for potential restoration (not currently used in the public filter UI).
export const CATEGORIES = ["All", "Residential", "Interior Architecture", "Styling & FF&E", "Concept"];

// Public Projects index filters — filter by project status.
export const STATUS_FILTERS = ["All", "Concept study"];

// status: "Concept study" | "In development" | "Completed"
export const PROJECTS = [
  {
    slug: "hyde-park-residence",
    title: "Hyde Park Residence",
    location: "Bayswater, London",
    year: "2025",
    status: "Concept study",
    scope: "Full-Service Residential Interiors",
    categories: ["Residential", "Interior Architecture"],
    cover: IMG.hydePark,
    coverCaption: "Concept visualisation",
    intro:
      "A lateral apartment overlooking the park, reconsidered as a sequence of calm, light-filled rooms in quiet dialogue with the greenery beyond.",
    narrative:
      "This residential concept explores a sequence of calm, light-filled rooms connected by a clearer circulation route and a restrained architectural language. Long views, integrated joinery and a limited material palette are used to create continuity while allowing each room to retain its own sense of enclosure.",
    challenge:
      "The study considers how a fragmented apartment layout might be reorganised to improve circulation, natural light and the relationship between principal rooms.",
    response:
      "The proposal introduces full-height joinery, a simplified material palette and carefully controlled junctions to create greater visual continuity from threshold to window.",
    materials: ["Warm chalk lime plaster", "Honed limestone", "Rift-sawn oak", "Aged bronze", "Olive-grey linen"],
    intendedAtmosphere:
      "Softly lit, tactile and restful — a home that changes gently with the light through the day.",
    gallery: [
      { src: IMG.hydePark, caption: "Concept visualisation — principal living space", wide: true },
    ],
    credits: ["Interior architecture & design — Arc & Hollow", "Visualisation — Arc & Hollow"],
  },
  {
    slug: "chelsea-townhouse",
    title: "Chelsea Townhouse",
    location: "Chelsea, London",
    year: "2025",
    status: "Concept study",
    scope: "Interior Architecture & Renovation",
    categories: ["Interior Architecture", "Concept"],
    cover: IMG.chelsea,
    coverCaption: "Concept visualisation",
    intro:
      "A conceptual study for a period townhouse, exploring the stair as a sculptural architectural element that draws light and movement through the centre of the home.",
    narrative:
      "Our early thinking centred on the stair as the emotional and architectural core of the house. Rather than a purely functional element, it becomes a slow, curving passage between the more public lower floors and the quiet of the upper rooms.",
    challenge:
      "The study examines how a deep townhouse plan could gain a stronger connection between floors while bringing borrowed daylight into its centre.",
    response:
      "The concept proposes a re-formed plaster stair drawing borrowed light down through a top-lit void, with recessed niches for objects and pause. Consultants would be appointed to develop structural and heritage considerations.",
    materials: ["Sculptural lime plaster", "Aged bronze handrail", "Soft limestone treads", "Clay-toned textiles"],
    intendedAtmosphere:
      "Quietly dramatic — a considered play of shadow, curve and daylight.",
    gallery: [
      { src: IMG.chelsea, caption: "Concept visualisation — stair and hallway", wide: true },
      { src: IMG.studioTexture, caption: "Material study — curved shadow on lime plaster" },
    ],
    credits: ["Concept design — Arc & Hollow", "Structural & heritage consultants to be appointed"],
  },
  {
    slug: "hampstead-apartment",
    title: "Hampstead Apartment",
    location: "Hampstead, London",
    year: "2024",
    status: "Concept study",
    scope: "Full-Service Residential Interiors",
    categories: ["Residential", "Full-Service Interiors", "Concept Study"],
    cover: IMG.hampstead,
    coverCaption: "Design development",
    intro:
      "A compact garden-level apartment where kitchen, dining and living are drawn together into a single, warm and highly resolved room.",
    narrative:
      "The design develops a quiet, hard-working plan in which every surface earns its place. Handleless oak and olive-grey cabinetry frame a honed limestone worktop, while a round pedestal table softens the geometry and invites gathering.",
    challenge:
      "A modest footprint needed to accommodate cooking, dining and relaxed living without feeling crowded or purely utilitarian.",
    response:
      "We proposed a restrained material palette and concealed storage, allowing a few considered pieces — the table, a sculptural pendant, a single artwork — to carry the room.",
    materials: ["Rift-sawn oak", "Olive-grey lacquer", "Honed limestone", "Aged bronze tapware"],
    intendedAtmosphere:
      "Warm, convivial and unhurried — a room that works as hard as it welcomes.",
    gallery: [
      { src: IMG.hampstead, caption: "Design development — kitchen and dining", wide: true },
    ],
    credits: ["Interior design — Arc & Hollow", "Visualisation — Arc & Hollow"],
  },
];

export const getProject = (slug) => PROJECTS.find((p) => p.slug === slug);
export const relatedProjects = (slug) => PROJECTS.filter((p) => p.slug !== slug).slice(0, 2);
